import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideEnvironment } from './providers/environment.provider';
import { errorInterceptor, jwtInterceptor } from '@dss-libs/shared/data-access/auth';
import { provideCurrentUserRole } from '@dss-libs/shared/data-access/users';
import {
  provideKeycloakWithConfig,
  provideLocale,
  provideTranslocoWithConfig,
  iconProviderInitializer,
} from '@dss-libs/shared/utility/app-providers';
import { environment } from '../environments/environment';
import { languageInterceptor, timezoneOffsetInterceptor } from '@dss-libs/shared/utility/common-interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([jwtInterceptor, errorInterceptor, languageInterceptor, timezoneOffsetInterceptor])
    ),
    provideTranslocoWithConfig(),
    provideEnvironment(),
    provideKeycloakWithConfig(environment.keycloak),
    provideLocale(),
    iconProviderInitializer(),
    provideCurrentUserRole(),
  ],
};
